import { exists } from '@/api'

export interface BatchNrcMarcContentRegConditionListItem {
  startNumFrom: string
  startNumTo: string
  rdoMarcType: string
  rdoMarcAlreadyExists: string
  collectionForm: string
  inputFileMarc: string
  memo: string
  batchType: string
}

export function BatchNrcMarcContentRegConditionListItemFromJSON(
  json: any
): BatchNrcMarcContentRegConditionListItem {
  const resp = JSON.parse(json)

  return {
    startNumFrom: exists(resp, 'start_num_from') ? resp.start_num_from : '',
    startNumTo: exists(resp, 'start_num_to') ? resp.start_num_to : '',
    rdoMarcType: exists(resp, 'rdo_marc_type') ? resp.rdo_marc_type : '2',
    rdoMarcAlreadyExists: exists(resp, 'rdo_marc_already_exists')
      ? resp.rdo_marc_already_exists
      : '1',
    collectionForm: exists(resp, 'collection_form') ? resp.collection_form : '',
    inputFileMarc: '',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
